import { render, staticRenderFns } from "./stock-transfer-create.vue?vue&type=template&id=f23add20&scoped=true"
import script from "./stock-transfer-create.vue?vue&type=script&lang=js"
export * from "./stock-transfer-create.vue?vue&type=script&lang=js"
import style0 from "./stock-transfer-create.vue?vue&type=style&index=0&id=f23add20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23add20",
  null
  
)

export default component.exports